import { buildPlanCode } from "helpers/subscription";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SubscriptionChangePreviewPayload } from "hooks/use-subscription-change-calculation";
import { ISubscription } from "store/entities/subscriptions";

import { BaseApi } from "../base";

export interface ISubscriptionPreviewParams {
  quantity: number;
  planCode: string;
  country?: string;
  couponCode?: string;
  postalCode?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function parseCreatePayload(data: Partial<ISubscription>) {
  return {
    quantity: data.agents,
    // @ts-expect-error TS(2345)
    planCode: buildPlanCode(data.plan, data.billingCycle),
    ...(data.couponCode && { couponCode: data.couponCode }),
  };
}

export default class SubscriptionApi extends BaseApi {
  protected readonly prefix = "subscriptions";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get("");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (data: Partial<ISubscription>) => this.post("", parseCreatePayload(data));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (data: Partial<ISubscription>) => this.patch(data.id, parseCreatePayload(data));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  preview = (id: string, data: ISubscriptionPreviewParams) =>
    this.post<SubscriptionChangePreviewPayload>(`${id}/preview`, data);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSubscription = (id: string) => this.patch(`${id}/terminate`);
}
